/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Eyebrow_TestimonialsInputs */

const en_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testimonials`)
};

const es_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testimonios`)
};

const de_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrungsberichte`)
};

const zh_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`感言`)
};

const ar_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شهادات`)
};

const fr_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Témoignages`)
};

const vi_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận xét`)
};

const sw_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ushuhuda`)
};

const th_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อความรับรอง`)
};

const bs_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preporuke`)
};

const ja_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お客様の声`)
};

const ko_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수강생 후기`)
};

const pt_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depoimentos`)
};

const it_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testimonianze`)
};

const sv_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omdömen`)
};

const nl_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ervaringen`)
};

const da_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udtalelser`)
};

const nb_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbakemeldinger`)
};

const fi_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asiakaskokemuksia`)
};

const pl_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opinie`)
};

const ru_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отзывы`)
};

const tr_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referanslar`)
};

const hi_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रशंसापत्र`)
};

const id_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testimonial`)
};

const ms_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testimoni`)
};

const cs_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svědectví`)
};

const el_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κριτικές μαθητών`)
};

const he_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עדויות`)
};

const af_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getuigskrifte`)
};

const hu_home_eyebrow_testimonials = /** @type {(inputs: Home_Eyebrow_TestimonialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vélemények`)
};

/**
* | output |
* | --- |
* | "Testimonials" |
*
* @param {Home_Eyebrow_TestimonialsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_eyebrow_testimonials = /** @type {((inputs?: Home_Eyebrow_TestimonialsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Eyebrow_TestimonialsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_eyebrow_testimonials(inputs)
	if (locale === "de") return de_home_eyebrow_testimonials(inputs)
	if (locale === "zh") return zh_home_eyebrow_testimonials(inputs)
	if (locale === "ar") return ar_home_eyebrow_testimonials(inputs)
	if (locale === "fr") return fr_home_eyebrow_testimonials(inputs)
	if (locale === "vi") return vi_home_eyebrow_testimonials(inputs)
	if (locale === "sw") return sw_home_eyebrow_testimonials(inputs)
	if (locale === "th") return th_home_eyebrow_testimonials(inputs)
	if (locale === "bs") return bs_home_eyebrow_testimonials(inputs)
	if (locale === "ja") return ja_home_eyebrow_testimonials(inputs)
	if (locale === "ko") return ko_home_eyebrow_testimonials(inputs)
	if (locale === "pt") return pt_home_eyebrow_testimonials(inputs)
	if (locale === "it") return it_home_eyebrow_testimonials(inputs)
	if (locale === "sv") return sv_home_eyebrow_testimonials(inputs)
	if (locale === "nl") return nl_home_eyebrow_testimonials(inputs)
	if (locale === "da") return da_home_eyebrow_testimonials(inputs)
	if (locale === "nb") return nb_home_eyebrow_testimonials(inputs)
	if (locale === "fi") return fi_home_eyebrow_testimonials(inputs)
	if (locale === "pl") return pl_home_eyebrow_testimonials(inputs)
	if (locale === "ru") return ru_home_eyebrow_testimonials(inputs)
	if (locale === "tr") return tr_home_eyebrow_testimonials(inputs)
	if (locale === "hi") return hi_home_eyebrow_testimonials(inputs)
	if (locale === "id") return id_home_eyebrow_testimonials(inputs)
	if (locale === "ms") return ms_home_eyebrow_testimonials(inputs)
	if (locale === "cs") return cs_home_eyebrow_testimonials(inputs)
	if (locale === "el") return el_home_eyebrow_testimonials(inputs)
	if (locale === "he") return he_home_eyebrow_testimonials(inputs)
	if (locale === "af") return af_home_eyebrow_testimonials(inputs)
	if (locale === "hu") return hu_home_eyebrow_testimonials(inputs)
	return en_home_eyebrow_testimonials(inputs)
});